import { Button, Size } from '@design/components/button/Button';
import { Tooltip, TooltipTrigger } from '@design/components/tooltip/Tooltip';
import { useMobileNavLayout } from '@terminal/hooks/use-mobile-nav-layout/useMobileNavLayout';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './NewChatButton.module.scss';

interface NewChatButtonProps {
  className?: string;
  iconOnly?: boolean;
  isHistoryExpanded?: boolean;
  onClick?: () => void;
  size?: Size;
}

export const NewChatButton = ({
  onClick,
  iconOnly = false,
  className,
  isHistoryExpanded = false,
  size,
}: NewChatButtonProps) => {
  const { t } = useTranslation(['chat']);
  const isMobileNavLayout = useMobileNavLayout();

  return (
    <Tooltip
      label={t('chat:historySidebar.newConversation')}
      disabled={isHistoryExpanded || isMobileNavLayout}
      trigger={TooltipTrigger.Hover}
      placement="right"
    >
      <Button
        className={clsx(styles.styledButton, className)}
        variant={'tertiary'}
        size={size ?? (isMobileNavLayout ? 'large' : 'small')}
        iconName="ChatNew"
        label={iconOnly ? undefined : t('chat:historySidebar.newConversation')}
        onClick={onClick}
      />
    </Tooltip>
  );
};
